import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { useLocation } from 'react-router-dom';
import BackToTop from '../../components/back-to-top/BackToTop';

const NAV_LINKS = [
    { label: 'Services',       to: 'services',     href: '/#services'     },
    { label: 'About Us',       to: 'about-us',     href: '/#about-us'     },
    { label: 'Client Stories', to: 'testimonials', href: '/#testimonials' },
    { label: 'Contact Us',     to: 'contacts',     href: '/#contacts'     },
];

const FooterNavLink = ({ label, to, href, isHome }) => {
    if (isHome) {
        return (
            <ScrollLink
                title={ label }
                to={ to }
                spy={ true }
                smooth={ true }
                duration={ 500 }
                offset={ -120 }
                href={ href }
                style={{ cursor: 'pointer' }}
            >
                { label }
            </ScrollLink>
        );
    }
    return <a title={ label } href={ process.env.PUBLIC_URL + href }>{ label }</a>;
};

const Footer = () => {
    const location = useLocation();
    const isHome = location.pathname === process.env.PUBLIC_URL + '/' || location.pathname === '/';

    return (
        <footer id="footer" className="site-footer">
            <div className="wrapper">
                <BackToTop />

                <div className="footer-grid">
                    {/* Column 1: Logo + tagline + social */}
                    <div className="footer-col footer-col-brand">
                        <div className="logo logo-secondary">
                            <img src="assets/img/logo/Z3-logo-light.png" alt="Z3 Info Systems Logo" />
                        </div>
                        <p className="footer-tagline">Delivering intelligent solutions</p>
                        <div className="footer-social">
                            <a href="https://www.linkedin.com/company/z3-info-systems" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-linkedin-in"></i>
                            </a>
                            <a href="https://twitter.com/z3_info" title="X" target="_blank" rel="noopener noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59h89.34M36.01 19.54H76.66l187.13 262.13h-40.66" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Column 2: Quick Links */}
                    <div className="footer-col">
                        <h5 className="footer-col-heading">Quick Links</h5>
                        <ul className="footer-links">
                            { NAV_LINKS.map( ( item ) => (
                                <li key={ item.to }>
                                    <FooterNavLink { ...item } isHome={ isHome } />
                                </li>
                            ) ) }
                            <li>
                                <a title="Blogs" href={ process.env.PUBLIC_URL + '/news' }>Blogs</a>
                            </li>
                        </ul>
                    </div>

                    {/* Column 3: Contact */}
                    <div className="footer-col">
                        <h5 className="footer-col-heading">Contact</h5>
                        <address className="footer-address">
                            1785 State Hwy 26, Suite 200<br />
                            Grapevine, TX 76051
                        </address>
                        <p className="footer-contact-item">
                            Phone: <a href="tel:+19142655072">+1 914 265 5072</a>
                        </p>
                        <p className="footer-contact-item">
                            Email: <a href="mailto:hello@z3info.com">hello@z3info.com</a>
                        </p>
                    </div>
                </div>

                {/* Bottom copyright bar */}
                <div className="footer-bottom">
                    <p>© 2025 Z3 Info Systems. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
